import {
  maxMonthFirstQuarter,
  maxMonthFourthQuarter,
  maxMonthSecondQuarter,
  maxMonthThirdQuarter,
  minMonthFirstQuarter,
  minMonthFourthQuarter,
  minMonthSecondQuarter,
  minMonthThirdQuarter,
} from 'app/config/constants';
import dayjs from 'dayjs';

export const getQuarterTitle = quarterNumber => `Quý ${quarterNumber}`;

export const quarterMapping = {
  1: { minMonth: minMonthFirstQuarter, maxMonth: maxMonthFirstQuarter, title: getQuarterTitle('I') },
  2: { minMonth: minMonthSecondQuarter, maxMonth: maxMonthSecondQuarter, title: getQuarterTitle('II') },
  3: { minMonth: minMonthThirdQuarter, maxMonth: maxMonthThirdQuarter, title: getQuarterTitle('III') },
  4: { minMonth: minMonthFourthQuarter, maxMonth: maxMonthFourthQuarter, title: getQuarterTitle('IV') },
};

export const formatNumber = value => {
  // Format the value as VND
  return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const formatNumberPercent = value => {
  // Format the value with proper decimal handling
  if (value === null || value === undefined || value === '') return '';
  const num = parseFloat(value);
  if (isNaN(num)) return value;
  
  // If the number has decimals, format with 2 decimal places
  if (num % 1 !== 0) {
    return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  // If it's a whole number, keep original format
  return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const formatNumberWithDecimals = value => {
  // Format the value with 2 decimal places
  if (value === null || value === undefined || value === '') return '';
  const num = parseFloat(value);
  if (isNaN(num)) return value;
  return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const formatPercent = value => {
  // Format the value for percentage with 2 decimal places
  if (value === null || value === undefined || value === '') return '';
  const num = parseFloat(value);
  if (isNaN(num)) return value;
  return num.toFixed(2);
};

export const parsePercent = value => {
  // Parse percentage value, remove any non-numeric characters except decimal point
  if (!value) return '';
  return value.replace(/[^\d.]/g, '');
};

export const parseNumber = value => {
  // Remove non-numeric characters and parse the value
  const parsedValue = value.replace(/₫\s?|(,*)/g, '');
  return parsedValue;
};

export const parseNumberPercent = value => {
  // Remove non-numeric characters except decimal point and parse the value
  if (!value) return '';
  const parsedValue = value.replace(/[^\d.]/g, '');
  return parsedValue;
};



export const TimeDifference = (time: Date) => {
  const startTime = dayjs(time);
  const currentTime = dayjs();
  const diffInMinutes = currentTime.diff(startTime, 'minute');
  const diffInHours = currentTime.diff(startTime, 'hour');
  const diffInDays = currentTime.diff(startTime, 'day');
  if (diffInDays > 0) {
    return `${diffInDays} ngày`;
  } else if (diffInHours > 0) {
    return `${diffInHours} giờ`;
  } else {
    return `${diffInMinutes} phút`;
  }
};
